<template>
    <div class="el-col el-col-24"> 
        <span :span="1" :offset="1">学年：</span>
        <el-select v-model="yearID" :span="6" @change="selectChange(yearID)">
            <el-option v-for="item in selectyears" :key="item.yearID" :label="item.yearName" :value="item.yearID"></el-option>
        </el-select>
        <span :span="1" :offset="1">体检类型：</span>
        <el-select v-model="selTjtype" placeholder="全部">
            <el-option v-for="item in tjtypes" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
        </el-select>
        <span :span="1" :offset="1">批次名称：</span>
        <el-select v-model="id" :span="6">
            <el-option v-for="item in selectBatch" :key="item.id" :label="item.batchName" :value="item.id"></el-option>
        </el-select>
    </div>
</template>
<script>
import { Select} from 'element-ui'
import api from '../../../com/ajax'
import config from '../../../com/config'

export default {
  name: 'app',
    components: {
        Select
    },
    data () {
        return {
            // 对象属性
            yearID:'',
            tjtypes:[{
                'value':'',
                'name':'全部',
            },{
                'value':'2',
                'name':'入园体检',
            },{
                'value':'3',
                'name':'六一体检',
            },{
                'value':'1',
                'name':'自定义体检',
            }],
            id:'',
            selectyears:[],
            selTjtype:'',
            selectBatch:[],
            orgID:''
        }
    },
    props:{
    },
    watch:{
       
    },
    methods:{
        selectChange(parentID){//由学年得到批次
            var that = this
             api.post(config.khsHost +'disease/forHhs/mecBatch/getBatchList.do',{"organId":that.orgID,"mecType":that.selTjtype,"classYearId":that.yearID}).then(function (response) {

                    if (response.success == true) {
                      
                        that.selectBatch = response.body.list
                    }
              
            })
        }
    },
    mounted: function(){  
    },
    created: function(){
        var that = this;
        getId.$on('change',function(val){
            that.orgID=val
            api.post(config.khsHost +'base/forHhs/term/getYearList.do',{"orgID":that.orgID}).then(function (response) {

                    if (response.success == true) {

                        that.selectyears = response.body.list
                        that.yearID = response.body.list[0].yearID
                        that.yearName=response.body.list[0].yearName
                        that.selTjtype=that.tjtypes[2].value
                        api.post(config.khsHost +'disease/forHhs/mecBatch/getBatchList.do',{"organId":that.orgID,"mecType":that.selTjtype,"classYearId":that.yearID}).then(function (response) {

                                if (response.success == true) {
                                  
                                    that.selectBatch = response.body.list
                                    that.id= response.body.list[0]
                                    
                                }
                          
                        })
                    }
              
            })
        })   
        
    },
    beforeDestroy: function () {

        // 销毁前状态
        getId.$off('change');
    },
}
</script>


// WEBPACK FOOTER //
// src/components/reports/codeCom/tjtype.vue?1d12b9f3